(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shokz-anchor-nav-script"] && !Shopify.designMode) return;
  try {
    class ShokzAnchorNav extends HTMLElement {
  connectedCallback() {
    this.initialize = this.initialize.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleVisibilityUpdate = this.handleVisibilityUpdate.bind(this);
    this.handleSectionChange = this.handleSectionChange.bind(this);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
    } else {
      this.initialize();
    }
  }

  initialize() {
    if (this.isInitialized || !this.isConnected) return;
    this.isInitialized = true;

    this.navigation = this.querySelector('.shokz-anchor-nav__track');
    this.links = Array.from(this.querySelectorAll('.shokz-anchor-nav__link'));
    this.activeLink = this.links.find((link) => link.classList.contains('is-active'));
    this.intersections = new Map();
    this.targetLinks = new Map();
    this.pendingLink = null;
    this.hideAtMarkers = this.hasAttribute('data-hide-at-markers');

    this.links.forEach((link) => link.addEventListener('click', this.handleLinkClick));
    this.refreshTargets();

    this.scrollContainers = [window, document.querySelector('.page-wrapper')].filter(Boolean);
    this.scrollContainers.forEach((container) => {
      container.addEventListener('scroll', this.handleScroll, { passive: true });
    });
    document.addEventListener('shopify:section:load', this.handleSectionChange);
    document.addEventListener('shopify:section:unload', this.handleSectionChange);

    if (!this.hideAtMarkers) return;

    this.anchorContainer = this.closest('.shokz-anchor-nav-section');
    this.refreshVisibilityTargets();
    window.addEventListener('resize', this.handleVisibilityUpdate);
    this.updateVisibility();
  }

  refreshTargets() {
    this.observer?.disconnect();
    this.intersections.clear();
    this.targetLinks.clear();

    this.links.forEach((link) => {
      const target = this.getTargetForLink(link);
      if (target) this.targetLinks.set(target, link);
    });

    const targets = Array.from(this.targetLinks.keys());
    if (!targets.length || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '-25% 0px -60% 0px',
      threshold: [0, 0.15, 0.5],
    });
    targets.forEach((target) => this.observer.observe(target));
  }

  getTargetForLink(link) {
    const href = link?.getAttribute('href');
    if (!href?.startsWith('#') || href === '#') return null;

    try {
      return document.getElementById(decodeURIComponent(href.slice(1)));
    } catch {
      return null;
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => this.intersections.set(entry.target, entry));
    if (!this.pendingLink) this.syncActiveLink();
  }

  handleLinkClick(event) {
    const link = event.currentTarget;
    if (!this.getTargetForLink(link)) return;

    this.pendingLink = link;
    this.setActiveLink(link);
    this.schedulePendingRelease();
  }

  handleScroll() {
    if (this.pendingLink) this.schedulePendingRelease();
    if (this.hideAtMarkers) this.handleVisibilityUpdate();
  }

  schedulePendingRelease() {
    window.clearTimeout(this.pendingReleaseTimer);
    this.pendingReleaseTimer = window.setTimeout(() => {
      this.pendingLink = null;
      this.syncActiveLink();
    }, 180);
  }

  syncActiveLink() {
    const visibleTargets = Array.from(this.targetLinks.keys()).filter(
      (target) => this.intersections.get(target)?.isIntersecting
    );
    if (!visibleTargets.length) return;

    const activationLine = window.innerHeight * 0.25;
    const activeTarget =
      visibleTargets.find((target) => {
        const rect = target.getBoundingClientRect();
        return rect.top <= activationLine && rect.bottom > activationLine;
      }) ||
      visibleTargets.sort((targetA, targetB) => {
        const distanceA = Math.abs(targetA.getBoundingClientRect().top - activationLine);
        const distanceB = Math.abs(targetB.getBoundingClientRect().top - activationLine);
        return distanceA - distanceB;
      })[0];

    this.setActiveLink(this.targetLinks.get(activeTarget));
  }

  setActiveLink(activeLink) {
    if (!activeLink || activeLink === this.activeLink) return;

    this.activeLink = activeLink;
    this.links.forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
    this.centerActiveLink(activeLink);
  }

  centerActiveLink(link) {
    if (!this.navigation || this.navigation.scrollWidth <= this.navigation.clientWidth) return;

    const navigationRect = this.navigation.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    const centeredScrollLeft =
      this.navigation.scrollLeft + linkRect.left - navigationRect.left - (navigationRect.width - linkRect.width) / 2;
    const maxScrollLeft = this.navigation.scrollWidth - this.navigation.clientWidth;

    this.navigation.scrollTo({
      left: Math.max(0, Math.min(maxScrollLeft, centeredScrollLeft)),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  handleVisibilityUpdate() {
    if (this.visibilityFrame) return;

    this.visibilityFrame = requestAnimationFrame(() => {
      this.visibilityFrame = null;
      this.updateVisibility();
    });
  }

  handleSectionChange() {
    cancelAnimationFrame(this.sectionChangeFrame);
    this.sectionChangeFrame = requestAnimationFrame(() => {
      this.sectionChangeFrame = null;
      this.refreshTargets();
      if (!this.hideAtMarkers) return;

      this.refreshVisibilityTargets();
      this.updateVisibility();
    });
  }

  refreshVisibilityTargets() {
    this.visibilityTargets = Array.from(document.querySelectorAll('[data-shokz-anchor-hide]'));
  }

  updateVisibility() {
    if (!this.anchorContainer || !this.visibilityTargets?.length) {
      this.setHidden(false);
      return;
    }

    const stickyTop = Number.parseFloat(getComputedStyle(this.anchorContainer).top) || 0;
    const hideBoundary = stickyTop + this.offsetHeight;
    const shouldHide = this.visibilityTargets.some((target) => {
      if (!target.isConnected) return false;

      const targetRect = target.getBoundingClientRect();
      return targetRect.top <= hideBoundary && targetRect.bottom > hideBoundary;
    });

    this.setHidden(shouldHide);
  }

  setHidden(shouldHide) {
    this.classList.toggle('is-hidden', shouldHide);
    this.anchorContainer?.classList.toggle('shokz-anchor-nav-section--hidden', shouldHide);
    this.toggleAttribute('inert', shouldHide);
    if (shouldHide) {
      this.setAttribute('aria-hidden', 'true');
    } else {
      this.removeAttribute('aria-hidden');
    }
  }

  disconnectedCallback() {
    document.removeEventListener('DOMContentLoaded', this.initialize);
    this.observer?.disconnect();
    this.links?.forEach((link) => link.removeEventListener('click', this.handleLinkClick));
    this.scrollContainers?.forEach((container) => container.removeEventListener('scroll', this.handleScroll));
    window.removeEventListener('resize', this.handleVisibilityUpdate);
    document.removeEventListener('shopify:section:load', this.handleSectionChange);
    document.removeEventListener('shopify:section:unload', this.handleSectionChange);
    window.clearTimeout(this.pendingReleaseTimer);
    cancelAnimationFrame(this.visibilityFrame);
    cancelAnimationFrame(this.sectionChangeFrame);
    this.pendingLink = null;
    this.visibilityFrame = null;
    this.sectionChangeFrame = null;
    this.setHidden(false);
    this.isInitialized = false;
  }
}

if (!customElements.get('shokz-anchor-nav')) {
  customElements.define('shokz-anchor-nav', ShokzAnchorNav);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-footer-script"] && !Shopify.designMode) return;
  try {
    class ShokzFooter extends HTMLElement {
  connectedCallback() {
    this.menus = [...this.querySelectorAll('[data-footer-menu]')];
    this.menuSummaries = [...this.querySelectorAll('[data-footer-menu-summary]')];
    this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
    this.languageDialog = this.querySelector('[data-footer-language-dialog]');
    this.languagePanel = this.querySelector('.shokz-footer__language-panel');
    this.languageOpenButton = this.querySelector('[data-footer-language-open]');
    this.languageCloseButton = this.querySelector('[data-footer-language-close]');
    this.languageInput = this.querySelector('[data-footer-language-input]');
    this.languageOptions = [...this.querySelectorAll('[data-footer-language-option]')];
    this.cookieSettingsButtons = [...this.querySelectorAll('[data-footer-cookie-settings]')];
    this.languageForm = this.languageInput?.form;

    this.menus.forEach((menu) => menu.addEventListener('toggle', this.handleMenuToggle));
    this.menuSummaries.forEach((summary) => summary.addEventListener('click', this.handleMenuSummaryClick));
    this.mobileMediaQuery.addEventListener('change', this.syncMenuState);
    this.syncMenuState();
    this.languageOpenButton?.addEventListener('click', this.openLanguageDialog);
    this.languageCloseButton?.addEventListener('click', this.closeLanguageDialog);
    this.languageDialog?.addEventListener('click', this.handleDialogBackdrop);
    this.languageOptions.forEach((option) => option.addEventListener('click', this.handleLanguageOption));
    this.cookieSettingsButtons.forEach((button) => button.addEventListener('click', this.openCookiePreferences));
  }

  disconnectedCallback() {
    this.menus?.forEach((menu) => menu.removeEventListener('toggle', this.handleMenuToggle));
    this.menuSummaries?.forEach((summary) => summary.removeEventListener('click', this.handleMenuSummaryClick));
    this.mobileMediaQuery?.removeEventListener('change', this.syncMenuState);
    this.languageOpenButton?.removeEventListener('click', this.openLanguageDialog);
    this.languageCloseButton?.removeEventListener('click', this.closeLanguageDialog);
    this.languageDialog?.removeEventListener('click', this.handleDialogBackdrop);
    this.languageOptions?.forEach((option) => option.removeEventListener('click', this.handleLanguageOption));
    this.cookieSettingsButtons?.forEach((button) =>
      button.removeEventListener('click', this.openCookiePreferences)
    );
  }

  handleMenuToggle = (event) => {
    if (!this.mobileMediaQuery.matches) {
      event.currentTarget.open = true;
      return;
    }

    if (!event.currentTarget.open) return;

    this.menus.forEach((menu) => {
      if (menu !== event.currentTarget) menu.open = false;
    });
  };

  handleMenuSummaryClick = (event) => {
    if (!this.mobileMediaQuery.matches) event.preventDefault();
  };

  syncMenuState = () => {
    this.menus.forEach((menu) => {
      menu.open = !this.mobileMediaQuery.matches;
    });
  };

  openLanguageDialog = () => {
    this.languageDialog?.showModal();
    // Browsers auto-focus the first focusable descendant (the active language
    // option) on showModal(), which paints its native focus ring on top of the
    // "is-active" border. Move focus to the inert panel instead so no option
    // appears focused/selected by default.
    this.languagePanel?.focus({ preventScroll: true });
  };

  closeLanguageDialog = () => {
    this.languageDialog?.close();
  };

  handleDialogBackdrop = (event) => {
    if (event.target !== this.languageDialog) return;

    const rect = this.languageDialog.getBoundingClientRect();
    const isInside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!isInside) this.languageDialog.close();
  };

  handleLanguageOption = (event) => {
    this.submitLanguage(event.currentTarget.value);
  };

  openCookiePreferences = () => {
    if (typeof window.privacyBanner?.showPreferences !== 'function') {
      console.warn('Shopify cookie preferences are unavailable. Check the store customer privacy settings.');
      return;
    }

    window.privacyBanner.showPreferences();
  };

  submitLanguage = (localeCode) => {
    if (!this.languageInput || !this.languageForm || !localeCode) return;

    if (localeCode === this.languageInput.value) {
      this.closeLanguageDialog();
      return;
    }

    this.languageInput.value = localeCode;
    this.languageForm.requestSubmit();
  };
}

if (!customElements.get('shokz-footer')) {
  customElements.define('shokz-footer', ShokzFooter);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-hearing-anatomy-script"] && !Shopify.designMode) return;
  try {
    class ShokzHearingAnatomy extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
    this.items = Array.from(this.querySelectorAll('[data-hearing-anatomy-item]'));
    this.mediaItems = Array.from(this.querySelectorAll('[data-hearing-anatomy-media]'));
    this.items.forEach((item) => {
      item.querySelector('[data-hearing-anatomy-trigger]')?.addEventListener('click', this.handleClick);
    });
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  disconnectedCallback() {
    this.items?.forEach((item) => {
      item.querySelector('[data-hearing-anatomy-trigger]')?.removeEventListener('click', this.handleClick);
    });
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleClick(event) {
    const selectedItem = event.currentTarget.closest('[data-hearing-anatomy-item]');
    if (!selectedItem) return;

    this.setActiveItem(selectedItem, !selectedItem.classList.contains('is-open'));
  }

  handleBlockSelect(event) {
    const selectedItem = event.target.closest('[data-hearing-anatomy-item]');
    if (!selectedItem || !this.contains(selectedItem)) return;

    this.setActiveItem(selectedItem, true);
  }

  setActiveItem(selectedItem, shouldOpen) {
    this.items.forEach((item) => {
      const isOpen = item === selectedItem && shouldOpen;
      item.classList.toggle('is-open', isOpen);
      item.querySelector('[data-hearing-anatomy-trigger]')?.setAttribute('aria-expanded', String(isOpen));
    });

    if (!shouldOpen) return;

    const selectedBlockId = selectedItem.dataset.hearingAnatomyBlockId;
    this.mediaItems.forEach((mediaItem) => {
      mediaItem.hidden = mediaItem.dataset.hearingAnatomyMedia !== selectedBlockId;
    });
  }
}

if (!customElements.get('shokz-hearing-anatomy')) {
  customElements.define('shokz-hearing-anatomy', ShokzHearingAnatomy);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-home-hero-script"] && !Shopify.designMode) return;
  try {
    class ShokzHomeCarousel extends HTMLElement {
  constructor() {
    super();
    this.showPrevious = this.showPrevious.bind(this);
    this.showNext = this.showNext.bind(this);
    this.handleDotClick = this.handleDotClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
  }

  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-shokz-banner-slide]')];
    this.dots = [...this.querySelectorAll('[data-shokz-banner-dot]')];
    this.previousButton = this.querySelector('[data-shokz-banner-previous]');
    this.nextButton = this.querySelector('[data-shokz-banner-next]');
    this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.hasAttribute('data-active')));

    if (this.slides.length < 2) return;

    this.previousButton?.addEventListener('click', this.showPrevious);
    this.nextButton?.addEventListener('click', this.showNext);
    this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    this.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.showPrevious);
    this.nextButton?.removeEventListener('click', this.showNext);
    this.dots?.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('touchstart', this.handleTouchStart);
    this.removeEventListener('touchend', this.handleTouchEnd);
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  showPrevious() {
    this.showSlide(this.currentIndex - 1);
  }

  showNext() {
    this.showSlide(this.currentIndex + 1);
  }

  handleDotClick(event) {
    this.showSlide(Number(event.currentTarget.dataset.shokzBannerDot));
  }

  handleKeydown(event) {
    if (event.key === 'ArrowLeft') this.showPrevious();
    if (event.key === 'ArrowRight') this.showNext();
  }

  handleTouchStart(event) {
    const touch = event.changedTouches[0];
    this.touchStart = { x: touch.clientX, y: touch.clientY };
  }

  handleTouchEnd(event) {
    if (!this.touchStart) return;

    const touch = event.changedTouches[0];
    const distanceX = touch.clientX - this.touchStart.x;
    const distanceY = touch.clientY - this.touchStart.y;
    this.touchStart = null;

    if (Math.abs(distanceX) < 40 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
    if (distanceX > 0) this.showPrevious();
    else this.showNext();
  }

  handleBlockSelect(event) {
    const selectedSlide = event.target.closest('[data-shokz-banner-slide]');
    if (!selectedSlide) return;

    this.showSlide(Number(selectedSlide.dataset.shokzBannerIndex));
  }

  showSlide(nextIndex) {
    const normalizedIndex = (nextIndex + this.slides.length) % this.slides.length;
    if (normalizedIndex === this.currentIndex) return;

    this.slides.forEach((slide, index) => {
      const isActive = index === normalizedIndex;
      slide.toggleAttribute('data-active', isActive);
      slide.toggleAttribute('inert', !isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    this.dots.forEach((dot, index) => {
      dot.setAttribute('aria-current', String(index === normalizedIndex));
    });

    this.currentIndex = normalizedIndex;
  }
}

if (!customElements.get('shokz-home-carousel')) {
  customElements.define('shokz-home-carousel', ShokzHomeCarousel);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-product-card-carousel-script"] && !Shopify.designMode) return;
  try {
    class ShokzProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
    this.dots = this.querySelector('[data-carousel-dots]');
    const section = this.closest('.shokz-card-carousel');
    this.previousButton = section?.querySelector('[data-carousel-prev]');
    this.nextButton = section?.querySelector('[data-carousel-next]');

    if (!this.track || this.slides.length < 2) return;

    this.activeIndex = 0;

    this.slides.forEach((slide, index) => {
      const dot = document.createElement('span');
      dot.className = `shokz-card-carousel__dot${index === 0 ? ' is-active' : ''}`;
      this.dots?.append(dot);
    });

    this.previousButton?.addEventListener('click', () => this.move(-1));
    this.nextButton?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });

    this.updateControls();
  }

  getMaxScrollLeft() {
    return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
  }

  move(direction) {
    const maxIndex = this.slides.length - 1;
    const targetIndex = Math.max(0, Math.min(maxIndex, this.activeIndex + direction));
    if (targetIndex === this.activeIndex) return;

    this.activeIndex = targetIndex;
    const targetSlide = this.slides[targetIndex];
    const targetRect = targetSlide.getBoundingClientRect();
    const trackRect = this.track.getBoundingClientRect();
    const targetLeft = this.track.scrollLeft + (targetRect.left - trackRect.left);

    this.track.scrollTo({ left: Math.max(0, Math.min(this.getMaxScrollLeft(), targetLeft)), behavior: 'smooth' });
    this.updateControls();
  }

  updateDots() {
    const distance = this.slides[0].getBoundingClientRect().width + 16;
    const activeIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / distance)));
    this.activeIndex = activeIndex;
    this.dots?.querySelectorAll('.shokz-card-carousel__dot').forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
    this.updateControls();
  }

  updateControls() {
    if (this.previousButton) this.previousButton.disabled = this.activeIndex <= 0;
    if (this.nextButton) this.nextButton.disabled = this.activeIndex >= this.slides.length - 1;
  }
}

if (!customElements.get('shokz-product-carousel')) {
  customElements.define('shokz-product-carousel', ShokzProductCarousel);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-professionals-evidence-script"] && !Shopify.designMode) return;
  try {
    class ShokzProfessionalsEvidence extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
    this.tabs = Array.from(this.querySelectorAll('[data-evidence-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-evidence-panel]'));
    this.tabs.forEach((tab) => tab.addEventListener('click', this.handleClick));
    this.tabs.forEach((tab) => tab.addEventListener('keydown', this.handleKeydown));
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => tab.removeEventListener('click', this.handleClick));
    this.tabs?.forEach((tab) => tab.removeEventListener('keydown', this.handleKeydown));
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleClick(event) {
    this.activateTab(event.currentTarget.dataset.evidenceTab);
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    if (nextIndex === undefined) return;

    event.preventDefault();
    this.activateTab(this.tabs[nextIndex].dataset.evidenceTab);
    this.tabs[nextIndex].focus();
  }

  handleBlockSelect(event) {
    const selectedTab = this.tabs.find((tab) => tab.dataset.evidenceBlockId === event.detail.blockId);
    if (selectedTab) this.activateTab(selectedTab.dataset.evidenceTab);
  }

  activateTab(selectedIndex) {
    if (selectedIndex === undefined) return;

    this.tabs.forEach((tab) => {
      const isSelected = tab.dataset.evidenceTab === selectedIndex;
      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.evidencePanel !== selectedIndex;
    });
  }
}

if (!customElements.get('shokz-professionals-evidence')) {
  customElements.define('shokz-professionals-evidence', ShokzProfessionalsEvidence);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-professionals-workflow-script"] && !Shopify.designMode) return;
  try {
    class ShokzProfessionalsWorkflow extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.steps = Array.from(this.querySelectorAll('[data-workflow-step]'));
    this.steps.forEach((step) => {
      step.querySelector('button')?.addEventListener('click', this.handleClick);
    });
  }

  disconnectedCallback() {
    this.steps?.forEach((step) => {
      step.querySelector('button')?.removeEventListener('click', this.handleClick);
    });
  }

  handleClick(event) {
    const selectedStep = event.currentTarget.closest('[data-workflow-step]');
    if (!selectedStep) return;

    this.steps.forEach((step) => {
      const isOpen = step === selectedStep ? !step.classList.contains('is-open') : false;
      step.classList.toggle('is-open', isOpen);
      step.querySelector('button')?.setAttribute('aria-expanded', String(isOpen));
    });
  }
}

if (!customElements.get('shokz-professionals-workflow')) {
  customElements.define('shokz-professionals-workflow', ShokzProfessionalsWorkflow);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-scroll-down-script"] && !Shopify.designMode) return;
  try {
    if (!window.shokzScrollDownInitialized) {
  window.shokzScrollDownInitialized = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-shokz-scroll-down]');
    if (!button) return;

    const targetSelector = button.getAttribute('href');
    if (!targetSelector?.startsWith('#') || targetSelector === '#') return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-support-faq-script"] && !Shopify.designMode) return;
  try {
    class ShokzSupportFaqList extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.items = Array.from(this.querySelectorAll('details'));

    let hasOpenItem = false;
    this.items.forEach((details) => {
      if (details.open && hasOpenItem) {
        details.open = false;
      } else if (details.open) {
        hasOpenItem = true;
      }

      details.addEventListener('toggle', this.handleToggle, { signal });
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  handleToggle = (event) => {
    const target = event.target;
    if (!target.open) return;

    this.items.forEach((details) => {
      if (details !== target) details.open = false;
    });
  };
}

if (!customElements.get('shokz-support-faq-list')) {
  customElements.define('shokz-support-faq-list', ShokzSupportFaqList);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-support-video-script"] && !Shopify.designMode) return;
  try {
    class ShokzSupportVideo extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-shokz-support-video-trigger]');
    this.dialog = this.querySelector('[data-shokz-support-video-dialog]');
    this.player = this.querySelector('[data-shokz-support-video-player]');

    this.trigger?.addEventListener('click', this.openDialog);
    this.dialog?.addEventListener('cancel', this.handleCancel);
    this.dialog?.addEventListener('click', this.handleDialogClick);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.openDialog);
    this.dialog?.removeEventListener('cancel', this.handleCancel);
    this.dialog?.removeEventListener('click', this.handleDialogClick);
    this.removePlayer();
    if (this.dialog?.open) this.dialog.close();
    this.updateScrollLock();
  }

  openDialog = () => {
    if (!this.dialog || this.dialog.open || !this.player) return;

    if (this.dataset.youtubeVideoId) {
      this.createPlayer();
      this.dataset.shokzPosterVisible = 'false';
    } else {
      this.dataset.shokzPosterVisible = 'true';
    }

    this.dialog.showModal();
    this.updateScrollLock();
    this.dialog.focus();
  };

  closeDialog = () => {
    if (!this.dialog?.open) return;

    this.dialog.close();
    this.removePlayer();
    this.dataset.shokzPosterVisible = 'true';
    this.updateScrollLock();
    this.trigger?.focus();
  };

  handleCancel = (event) => {
    event.preventDefault();
    this.closeDialog();
  };

  handleDialogClick = (event) => {
    if (event.target === this.dialog) this.closeDialog();
  };

  createPlayer() {
    if (this.player.querySelector('iframe')) return;

    const iframe = document.createElement('iframe');
    const videoId = encodeURIComponent(this.dataset.youtubeVideoId);

    iframe.className = 'shokz-support-video__video';
    iframe.setAttribute('data-shokz-support-video-active', '');
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`;
    iframe.title = this.dataset.youtubeVideoTitle || 'YouTube video';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.frameBorder = '0';

    this.player.append(iframe);
  }

  removePlayer() {
    this.player?.querySelector('iframe')?.remove();
  }

  updateScrollLock() {
    const hasOpenDialog = document.querySelector('.shokz-support-video__dialog[open]');
    document.documentElement.classList.toggle('shokz-support-video-is-open', Boolean(hasOpenDialog));
  }
}

if (!customElements.get('shokz-support-video')) {
  customElements.define('shokz-support-video', ShokzSupportVideo);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-video-showcase-script"] && !Shopify.designMode) return;
  try {
    class ShokzVideoShowcase extends HTMLElement {
  connectedCallback() {
    this.videos = [...this.querySelectorAll('[data-shokz-video-variant]')];
    if (!this.videos.length) return;

    this.playButton = this.querySelector('[data-shokz-video-play]');
    this.muteButton = this.querySelector('[data-shokz-video-mute]');
    this.mobileMedia = window.matchMedia('(max-width: 989px)');
    this.isMuted = true;
    this.controlsHideTimer = null;

    this.playButton?.addEventListener('click', this.handlePlayButtonClick);
    this.muteButton?.addEventListener('click', this.handleMuteButtonClick);
    this.mobileMedia.addEventListener('change', this.handleViewportChange);
    this.videos.forEach((video) => {
      video.addEventListener('click', this.handleVideoClick);
      video.addEventListener('play', this.handlePlay);
      video.addEventListener('playing', this.handlePlaying);
      video.addEventListener('pause', this.handlePause);
      video.addEventListener('ended', this.handleEnded);
    });

    this.setPosterVisibility(true);
    this.updatePlaybackState('loading');
    this.activateVideo(true);
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.handlePlayButtonClick);
    this.muteButton?.removeEventListener('click', this.handleMuteButtonClick);
    this.mobileMedia?.removeEventListener('change', this.handleViewportChange);
    this.clearControlsHideTimer();
    this.videos?.forEach((video) => {
      video.removeEventListener('click', this.handleVideoClick);
      video.removeEventListener('play', this.handlePlay);
      video.removeEventListener('playing', this.handlePlaying);
      video.removeEventListener('pause', this.handlePause);
      video.removeEventListener('ended', this.handleEnded);
      video.pause();
    });
  }

  getTargetVideo() {
    const preferredVariant = this.mobileMedia.matches ? 'mobile' : 'desktop';
    return (
      this.videos.find((video) => video.dataset.shokzVideoVariant === preferredVariant) || this.videos[0]
    );
  }

  activateVideo(shouldAutoplay = false) {
    const targetVideo = this.getTargetVideo();
    if (!targetVideo) return;

    this.videos.forEach((video) => {
      const isActive = video === targetVideo;
      video.toggleAttribute('data-shokz-video-active', isActive);
      if (!isActive) video.pause();
    });

    this.activeVideo = targetVideo;
    this.activeVideo.muted = this.isMuted;
    this.updateMuteButton();

    if (shouldAutoplay) {
      this.activeVideo.play().catch(() => this.updatePlaybackState('paused'));
    } else {
      this.updatePlaybackState(this.activeVideo.paused ? 'paused' : 'playing');
    }
  }

  handleViewportChange = () => {
    const previousVideo = this.activeVideo;
    const wasPlaying = previousVideo && !previousVideo.paused && !previousVideo.ended;
    const wasEnded = previousVideo?.ended || this.dataset.shokzPlayback === 'ended';
    const playbackTime = previousVideo?.currentTime || 0;

    this.hideMobileControls();
    this.activateVideo(false);
    if (this.activeVideo === previousVideo) return;

    this.activeVideo.currentTime = Math.min(playbackTime, this.activeVideo.duration || playbackTime);
    if (wasPlaying) {
      this.setPosterVisibility(true);
      this.activeVideo.play().catch(() => this.updatePlaybackState('paused'));
    } else if (wasEnded) {
      this.updatePlaybackState('ended');
    }
  };

  handlePlayButtonClick = (event) => {
    this.togglePlayback();
    this.releasePointerFocus(event);
  };

  handleMuteButtonClick = (event) => {
    this.toggleMute();
    this.showMobileControls();
    this.releasePointerFocus(event);
  };

  handleVideoClick = () => {
    if (this.mobileMedia.matches) {
      this.showMobileControls();
      return;
    }

    this.togglePlayback();
  };

  togglePlayback = () => {
    if (!this.activeVideo) return;

    if (this.activeVideo.paused || this.activeVideo.ended) {
      if (this.activeVideo.ended || this.dataset.shokzPlayback === 'ended') {
        this.activeVideo.currentTime = 0;
      }
      this.activeVideo.play().catch(() => this.updatePlaybackState('paused'));
    } else {
      this.activeVideo.pause();
    }
  };

  toggleMute = () => {
    this.isMuted = !this.isMuted;
    this.videos.forEach((video) => {
      video.muted = this.isMuted;
    });
    this.updateMuteButton();
  };

  showMobileControls() {
    if (!this.mobileMedia.matches || this.dataset.shokzPlayback !== 'playing') return;

    this.dataset.shokzControlsVisible = 'true';
    this.clearControlsHideTimer();
    this.controlsHideTimer = window.setTimeout(() => {
      this.hideMobileControls();
    }, 3000);
  }

  hideMobileControls() {
    this.clearControlsHideTimer();
    delete this.dataset.shokzControlsVisible;
  }

  clearControlsHideTimer() {
    if (this.controlsHideTimer === null) return;

    window.clearTimeout(this.controlsHideTimer);
    this.controlsHideTimer = null;
  }

  releasePointerFocus(event) {
    if (event.detail > 0) event.currentTarget.blur();
  }

  handlePlay = (event) => {
    if (event.currentTarget !== this.activeVideo) return;

    this.hideMobileControls();
    this.updatePlaybackState('playing');
  };

  handlePlaying = (event) => {
    if (event.currentTarget === this.activeVideo) this.setPosterVisibility(false);
  };

  handlePause = (event) => {
    if (event.currentTarget === this.activeVideo && !this.activeVideo.ended) {
      this.hideMobileControls();
      this.updatePlaybackState('paused');
    }
  };

  handleEnded = (event) => {
    if (event.currentTarget !== this.activeVideo) return;

    this.hideMobileControls();
    this.setPosterVisibility(true);
    this.updatePlaybackState('ended');
  };

  setPosterVisibility(isVisible) {
    this.dataset.shokzPosterVisible = String(isVisible);
  }

  updatePlaybackState(state) {
    this.dataset.shokzPlayback = state;
    const isPlaying = state === 'playing';
    this.playButton?.setAttribute('aria-pressed', String(isPlaying));
    this.playButton?.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }

  updateMuteButton() {
    this.dataset.shokzMuted = String(this.isMuted);
    this.muteButton?.setAttribute('aria-pressed', String(this.isMuted));
    this.muteButton?.setAttribute('aria-label', this.isMuted ? 'Unmute video' : 'Mute video');
  }
}

if (!customElements.get('shokz-video-showcase')) {
  customElements.define('shokz-video-showcase', ShokzVideoShowcase);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shokz-youtube-preview-script"] && !Shopify.designMode) return;
  try {
    class ShokzYoutubePreview extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-shokz-youtube-trigger]');
    this.dialog = this.querySelector('[data-shokz-youtube-dialog]');
    this.closeButton = this.querySelector('[data-shokz-youtube-close]');
    this.player = this.querySelector('[data-shokz-youtube-player]');
    this.thumbnail = this.querySelector('[data-shokz-youtube-thumbnail]');

    this.trigger?.addEventListener('click', this.openDialog);
    this.closeButton?.addEventListener('click', this.closeDialog);
    this.dialog?.addEventListener('cancel', this.handleCancel);
    this.dialog?.addEventListener('click', this.handleDialogClick);
    this.thumbnail?.addEventListener('error', this.handleThumbnailError);

    if (this.thumbnail?.complete && this.thumbnail.naturalWidth === 0) {
      this.handleThumbnailError();
    }
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.openDialog);
    this.closeButton?.removeEventListener('click', this.closeDialog);
    this.dialog?.removeEventListener('cancel', this.handleCancel);
    this.dialog?.removeEventListener('click', this.handleDialogClick);
    this.thumbnail?.removeEventListener('error', this.handleThumbnailError);
    this.removePlayer();
    if (this.dialog?.open) this.dialog.close();
    this.updateScrollLock();
  }

  openDialog = () => {
    if (!this.dialog || this.dialog.open || !this.player || !this.dataset.youtubeVideoId) return;

    this.createPlayer();
    this.dialog.showModal();
    this.updateScrollLock();
    this.closeButton?.focus();
  };

  closeDialog = () => {
    if (!this.dialog?.open) return;

    this.dialog.close();
    this.removePlayer();
    this.updateScrollLock();
    this.trigger?.focus();
  };

  handleCancel = (event) => {
    event.preventDefault();
    this.closeDialog();
  };

  handleDialogClick = (event) => {
    if (event.target === this.dialog) this.closeDialog();
  };

  handleThumbnailError = () => {
    const fallbackSrc = this.thumbnail?.dataset.shokzYoutubeFallbackSrc;

    if (fallbackSrc) {
      delete this.thumbnail.dataset.shokzYoutubeFallbackSrc;
      this.thumbnail.src = fallbackSrc;
      return;
    }

    this.dataset.shokzThumbnailError = 'true';
  };

  createPlayer() {
    if (this.player.firstElementChild) return;

    const iframe = document.createElement('iframe');
    const videoId = encodeURIComponent(this.dataset.youtubeVideoId);

    iframe.className = 'shokz-youtube-preview__iframe';
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.title = this.dataset.youtubeVideoTitle || 'YouTube video';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;

    this.player.append(iframe);
  }

  removePlayer() {
    this.player?.replaceChildren();
  }

  updateScrollLock() {
    const hasOpenDialog = document.querySelector('.shokz-youtube-preview__dialog[open]');
    document.documentElement.classList.toggle('shokz-youtube-preview-is-open', Boolean(hasOpenDialog));
  }
}

if (!customElements.get('shokz-youtube-preview')) {
  customElements.define('shokz-youtube-preview', ShokzYoutubePreview);
}
  } catch(e) { console.error(e); }
})();

})();
